import { render, staticRenderFns } from "./PDFReader.vue?vue&type=template&id=17f45eb0&scoped=true&lang=pug"
import script from "./PDFReader.vue?vue&type=script&lang=js"
export * from "./PDFReader.vue?vue&type=script&lang=js"
import style0 from "./PDFReader.vue?vue&type=style&index=0&id=17f45eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f45eb0",
  null
  
)

export default component.exports